/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 14:13
 */

import Vue from 'vue';
import VueRouter from 'vue-router';

// 组件
import HomePage from '../views/pages/homePage/homePage.vue'; // 首页
import SiteManage from '../views/pages/siteManage/siteManage.vue'; // 网点管理
import SiteInfo from '../views/pages/siteInfo'; // 网点管理-网点信息
import PeriodicalManage from '../views/pages/periodicalManage/periodicalManage.vue'; // 期刊管理
import PublishQiKan from '../views/pages/periodicalManage/publishQiKan.vue'; // 期刊管理
import InnerActivityManage from '../views/pages/innerActivityManage/innerActivityManage.vue'; // 活动管理-内部活动管理
import OutActivityManage from '../views/pages/outActivityManage/outActivityManage.vue'; // 活动管理-内部活动管理
import PromotionActivity from '../views/pages/promotionActivity/promotionActivity.vue'; // 活动管理-促销活动
import PromotionEdit from '../views/pages/promotionEdit/promotionEdit.vue'; // 活动管理-促销活动编辑
import PromotionDetailEdit from '../views/pages/promotionDetailEdit/promotionDetailEdit.vue'; // 活动管理-促销活动第二步编辑
import RecruitConfirmManage from '../views/pages/recruitConfirmManage/recruitConfirmManage.vue'; // 顾客分销管理-报名审核管理
import DistributeManage from '../views/pages/distributeManage/distributeManage.vue'; // 顾客分销管理-分销商品管理
import VirtualManager from '../views/pages/virtualManager/virtualManager.vue'; // 顾客分销管理-虚拟店长管理
import VirtualManagerInfo from '../views/pages/virtualManageInfo/virtualManageInfo.vue'; // 顾客分销管理-虚拟店长管理-虚拟店长信息
import RemitManage from '../views/pages/remitManage/remitManage.vue'; // 顾客分销管理-提现管理
import DepositManage from '../views/pages/depositManage/depositManage.vue'; // 顾客分销管理-押金管理
import TryOnBoard from '../views/pages/tryOnBoard/tryOnBoard.vue'; // 试穿报表
import OrdersManage from '../views/pages/ordersManage/ordersManage.vue'; // 订单管理
import DistributeList from '../views/pages/distributeBoard/distributeList.vue'; // 分销报表
import DistributeBoardInfo from '../views/pages/distributeBoardInfo/distributeBoardInfo.vue'; // 分销报表
import AppSumUpBoard from '../views/pages/appSumUpBoard/appSumUpBoard.vue'; // 小程序综合报表
import SiteTryOn from '../views/pages/siteTryOn/siteTryOn.vue'; // 网点试穿报表
import AppSetting from '../views/pages/appSetting/appSetting.vue'; // 基础设置-云镜店设置(小程序设置)
import AppConfig from '../views/pages/appConfig/appConfig.vue'; // 基础设置-云镜店设置(小程序设置)-小程序配置
import ActivityTypeSetting from '../views/pages/activityTypeSetting/activityTypeSetting.vue'; // 基础设置-活动类型设置
import ActivityTypeEdit from '../views/pages/activityTypeEdit/activityTypeEdit.vue'; // 基础设置-活动类型设置-编辑/添加活动类型
import TryOnAndExampleSetting from '../views/pages/tryOnAndExampleSetting/tryOnAndExampleSetting.vue'; // 基础设置-试穿及出样设置
import DistributeStrategySetting from '../views/pages/distributeStrategySetting/distributeStrategySetting.vue'; // 基础设置-分销策略设置
import DistributeStrategyEdit from '../views/pages/distributeStrategyEdit/distributeStrategyEdit.vue'; // 基础设置-分销策略设置-分销策略编辑
import Seckill from '../views/pages/seckill/seckill.vue'; // 营销中心-秒杀活动
import SeckillEdit from '../views/pages/seckillEdit/seckillEdit.vue'; // 营销中心-秒杀活动-新增/编辑
import Extended from '../views/pages/extended/extended.vue'; // 基础设置-其他
import VideoManage from '../views/pages/videoManage/videoManage.vue'; // 直播管理
import EditVideo from '../views/pages/editVideo/editVideo.vue'; // 新增/编辑/查看直播
import AssembleActEdit from '../views/pages/assembleActEdit/assembleActEdit.vue'; // 编辑拼团活动
import AssembleActivity from '../views/pages/assembleActivity/assembleActivity.vue'; // 拼团活动
import SeckillGroup from '../views/pages/seckillGroup/seckillGroup.vue'; // 营销中心-秒杀组活动
import SeckillGroupEdit from '../views/pages/seckillGroupEdit/seckillGroupEdit.vue'; // 营销中心-秒杀组活动新增/编辑
import Err from '../views/pages/others/err.vue'; // 错误页
import ShopDisplayManager from '../views/pages/shopDisplayManager/shopDisplayManager.vue';
import PostageManage from '../views/pages/postageManage/postageManage.vue';
import PostageInfo from '../views/pages/editPostage/editPostage.vue';
import CreateCorner from '../views/pages/createCorner/createCorner';

Vue.use(VueRouter);

const appRouter = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/', // 要有默认子路由，那父路由的名字name得去掉
      component: HomePage,
      meta: { requireLogin: true },
      // 有children的场合，适用于在页面内嵌套，也就是说，组件的页面内也存在<router-view>
      children: [
        // {path:'/', redirect : {name:"siteManage"}}, // 默认路由,跳转到网点设置
        { path: '/siteManage', name: 'siteManage', component: SiteManage }, // 网点管理
        { path: 'shopDisplayManager', component: ShopDisplayManager },
        { path: '/siteManage/site/:siteId/:code/:sgId/:mode/:page/:isMoreSite', component: SiteInfo }, // 网点管理-网点信息
        { path: '/periodicalManage', component: PeriodicalManage }, // 期刊管理
        { path: '/publishQiKan', component: PublishQiKan }, // 期刊管理-发布期刊
        { path: '/innerActivityManage', component: InnerActivityManage }, // 活动管理-内部活动管理
        { path: '/outActivityManage', component: OutActivityManage }, // 活动管理-外部活动管理
        { path: '/promotionActivity', component: PromotionActivity }, // 活动管理-促销活动
        { path: '/promotionEdit', component: PromotionEdit }, // 活动管理-促销活动编辑
        { path: '/promotionDetailEdit', component: PromotionDetailEdit }, // 活动管理-促销活动第二步编辑
        { path: '/assembleActivity', component: AssembleActivity }, // 拼团活动
        { path: '/assembleActEdit/:id/:state', component: AssembleActEdit }, // 编辑拼团活动
        { path: '/seckill', component: Seckill }, // 营销中心-秒杀活动
        { path: '/seckill/:id/:state', component: SeckillEdit }, // 营销中心-秒杀活动-新增/编辑
        { path: '/recruitConfirmManage', component: RecruitConfirmManage }, // 顾客分销管理-报名审核管理
        { path: '/distributeManage', component: DistributeManage }, // 顾客分销管理-分销商品管理
        { path: '/virtualManager', component: VirtualManager }, // 顾客分销管理-虚拟店长管理
        { path: '/virtualManager/manager/:id/:vGuiderSource', component: VirtualManagerInfo }, // 顾客分销管理-虚拟店长管理-虚拟店长信息
        { path: '/vGuiderReport/manager/:id/:vGuiderSource', component: VirtualManagerInfo }, // =============================
        { path: '/remitManage', component: RemitManage }, // 顾客分销管理-提现管理
        { path: '/depositManage', component: DepositManage }, // 顾客分销管理-押金管理
        { path: '/tryOnBoard', component: TryOnBoard }, // 试穿报表
        { path: '/ordersManage', component: OrdersManage }, // 订单管理
        { path: '/distributeBoard', component: DistributeList }, // 分销报表
        { path: '/distributeBoard/info/:id', component: DistributeBoardInfo }, // 分销报表
        { path: '/appSumUpBoard', component: AppSumUpBoard }, // 小程序综合报表
        { path: '/tryOnBoard/site/:id', component: SiteTryOn }, // 网点试穿报表
        { path: '/appSetting', component: AppSetting }, // 基础设置-云镜店设置(小程序设置)
        { path: '/appSetting/site/:id/:mode/:curPage/:isMoreSite', component: AppConfig }, // 基础设置-云镜店设置(小程序设置)-小程序配置
        { path: '/activityTypeSetting', component: ActivityTypeSetting }, // 基础设置-活动类型设置
        { path: '/activityTypeSetting/edit/:id', component: ActivityTypeEdit }, // 基础设置-活动类型设置-编辑/添加活动类型
        { path: '/tryOnAndExampleSetting', component: TryOnAndExampleSetting }, // 基础设置-试穿及出样设置
        { path: '/distributeStrategySetting', component: DistributeStrategySetting }, // 基础设置-分销策略设置
        { path: '/distributeStrategySetting/edit/:id', component: DistributeStrategyEdit }, // 基础设置-分销策略设置-分销策略编辑
        { path: '/videoManage', component: VideoManage }, // 直播管理
        { path: '/videoManage/:id/:type', component: EditVideo }, // 新增/编辑/查看直播
        { path: '/postageManage', component: PostageManage }, // 运费模板管理
        { path: '/postageInfo/:id/:type', component: PostageInfo },
        { path: '/extended', component: Extended }, //  基础设置-其他
        { path: '/createcorner/:siteId/:code/:sgId/:mode/:page/:isMoreSite', component: CreateCorner }, // 营销中心-秒杀活动
        { path: '/seckillGroup', component: SeckillGroup }, // 营销中心-秒杀组活动
        { path: '/seckillGroupEdit/:id', component: SeckillGroupEdit }, // 营销中心-秒杀组活动新增编辑
      ],
    },
    { path: '/err', name: 'err', component: Err },
    { path: '*', redirect: { name: 'err' } },
  ],
});

export default appRouter;
